// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__6kjDh","row":"styles_row__KFGjY"};